module.exports = __webpack_public_path__ + "img/live-banner.00092681.png";